'use client'

import { ApiClient } from 'api/client/apiClient'

const apiClient = () => {
  // const url = process.env.NEXT_PUBLIC_WEBSITE_URL ?? ''
  const env = process.env.NODE_ENV
  const client = new ApiClient('', env)
  return client
}

export default apiClient()
